import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useStore } from "../../store";
import InlineLoader from "../../components/atoms/inlineLoader";
import Loader from "../../components/atoms/loader";
import ErrorAlert from "../../components/atoms/alerts/errorAlert";
import SuccessAlert from "../../components/atoms/alerts/successAlert";
const PasswordReset = () => {
    const title = 'Company Login';
    const { layoutStore } = useStore();
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    // Get token from url
    const navigate = useNavigate();
    const token = window.location.pathname.split("/")[2];
    useEffect(() => {
        layoutStore.checkResetLink(token).then((resp) => {
            if (resp.error) {
                navigate("/login");
            }
            setPageLoading(false);
        });
    }, []);
    return (
        <>
            {pageLoading ? <Loader /> : null}
            {!pageLoading ? (
                <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <h1 className='font-black text-2xl text-center cursor-pointer border-b-2 pb-2 text-blue-700'
                        >
                            {title}
                        </h1>
                        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
                            Reset Your Password
                        </h2>
                    </div>

                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                            {error && <ErrorAlert title={error} />}
                            {success && <SuccessAlert title={success}
                                message="You will be redirected to the login page in a few seconds"
                            />}
                            <form className="space-y-6"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    setLoading(true);
                                    setError("");
                                    setSuccess("");
                                    const password = e.target.password.value;
                                    const RePassword = e.target.RePassword.value;
                                    if (password !== RePassword) {
                                        setError("Passwords do not match");
                                        setLoading(false);
                                        return;
                                    };
                                    layoutStore.resetPassword(token, password).then((resp) => {
                                        if (resp.error) {
                                            setError(resp.error);
                                            setLoading(false);
                                            return;
                                        }
                                        else {
                                            setSuccess("Password Reset Successful");
                                            setTimeout(() => {
                                                navigate("/login");
                                            }, 2000);
                                        }
                                    });
                                }}
                            >

                                <div>
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                        Password
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            autoComplete="current-password"
                                            required
                                            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                        Re-Enter  Password
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="RePassword"
                                            name="RePassword"
                                            type="password"
                                            autoComplete="current-password"
                                            required
                                            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
                                        />
                                    </div>
                                </div>

                                <div className="flex items-center justify-between">

                                </div>

                                <div>
                                    <button
                                        type="submit"
                                        disabled={loading}
                                        className="flex w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                    >

                                        {
                                            loading ? "Please wait..." : "Reset Password"
                                        }
                                        {
                                            loading && <InlineLoader />
                                        }
                                    </button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            ) : null}
        </>
    )
}
export default PasswordReset;